module.exports = __webpack_public_path__ + "static/img/logo_min.26246ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_min.png
// module id = 211
// module chunks = 17